module.exports = __webpack_public_path__ + "img/logoCAS.e243d3c1.png";